import React, { useState, useEffect } from 'react';
import axios from 'axios';

const DLATradeAwards = () => {
  const [awardCategories, setAwardCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Initialize axios instance
  const api = axios.create({
    baseURL: "https://backend.dlapakistan.com/api/dla-trade",
    headers: { "Content-Type": "application/json" },
    timeout: 10000,
  });

  // Fetch award categories from backend
  useEffect(() => {
    const fetchAwardCategories = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await api.get("/trade-awards/categories/");
        
        if (response.data && Array.isArray(response.data)) {
          // Sort by year descending (newest first)
          const sortedCategories = [...response.data].sort((a, b) => b.year - a.year);
          setAwardCategories(sortedCategories);
        } else {
          setAwardCategories([]);
        }
      } catch (error) {
        console.error("Error fetching award categories:", error);
        setError("Unable to load award categories. Please try again later.");
        setAwardCategories([]);
      } finally {
        setLoading(false);
      }
    };

    fetchAwardCategories();
  }, []);

  // Format the category name for display
  const getCategoryDisplayName = (category) => {
    // Check if the category name already contains the year
    if (category.name.includes(category.year)) {
      return category.name;
    }
    // Otherwise, append the year
    return `${category.name} ${category.year}`;
  };

  // Function to handle award category click
  const handleAwardClick = (category) => {
    // You can implement navigation logic here
    // For example, using react-router-dom navigation
    console.log(`Clicked on award: ${category.name} ${category.year}`);
    // If you're using react-router-dom, you could do:
    // navigate(`/dlatrade/awards/${category.year}`);
  };

  return (
    <div className="max-w-7xl mx-auto p-6 font-sans text-[#333333]">
     
      {/* Main Page Title */}
      <h1 className="text-[42px] font-normal mb-4 text-[#3c4858]">DLA Trade Awards</h1>
      
      {/* Visual Separation Line */}
      <hr className="border-t border-gray-200 mb-10" />

      {/* Loading State */}
      {loading && (
        <div className="flex justify-center items-center py-10">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#70B444]"></div>
          <span className="ml-3 text-gray-600">Loading award categories...</span>
        </div>
      )}

      {/* Error State */}
      {error && !loading && (
        <div className="text-center py-10">
          <div className="text-red-500 mb-3">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <p className="text-gray-700 mb-4">{error}</p>
          <button 
            onClick={() => window.location.reload()}
            className="px-4 py-2 bg-[#70B444] text-white rounded hover:bg-[#5d9a38] transition-colors"
          >
            Retry
          </button>
        </div>
      )}

      {/* Empty State */}
      {!loading && !error && awardCategories.length === 0 && (
        <div className="text-center py-10">
          <div className="text-gray-400 mb-3">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
            </svg>
          </div>
          <p className="text-gray-600 mb-2">No award categories available yet.</p>
          <p className="text-gray-500 text-sm">Create award categories in the admin panel to see them here.</p>
        </div>
      )}

      {/* Awards Links List - Updated to Green #70B444 */}
      {!loading && !error && awardCategories.length > 0 && (
        <div className="space-y-4">
          {awardCategories.map((category) => (
            <div key={category.id} className="group">
              <button
                onClick={() => handleAwardClick(category)}
                className="text-left w-full transition-all duration-200 hover:bg-gray-50 p-3 rounded-lg"
              >
                <span className="text-[24px] text-[#70B444] hover:underline cursor-pointer font-normal group-hover:text-[#5d9a38]">
                  {getCategoryDisplayName(category)}
                </span>
                {category.image_count !== undefined && category.image_count > 0 && (
                  <span className="ml-3 text-sm text-gray-500">
                    ({category.image_count} image{category.image_count !== 1 ? 's' : ''})
                  </span>
                )}
              </button>
            </div>
          ))}
        </div>
      )}

      {/* Add some helpful information */}
      {!loading && awardCategories.length > 0 && (
        <div className="mt-12 pt-8 border-t border-gray-200">
          <div className="bg-gray-50 p-4 rounded-lg">
        
        
          </div>
        </div>
      )}
    </div>
  );
};

export default DLATradeAwards;